module.exports = __webpack_public_path__ + "static/media/bzz.83f97d15.png";